/* Progressive enhancement: links, prices and the Shopify form work without JS. */
(() => {
  function initialize(root) {
    if (root.dataset.apparelInitialized) return;
    root.dataset.apparelInitialized = 'true';
    const controls = root.querySelector('.mcta-price-controls');
    if (controls) controls.hidden = false;
    function showPricing(product) {
      root.querySelectorAll('[data-pricing-product]').forEach((panel) => {
        panel.hidden = product !== 'all' && panel.dataset.pricingProduct !== product;
      });
      root.querySelectorAll('[data-pricing-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.pricingFilter === product));
      });
    }
    if (window.matchMedia('(max-width: 749px)').matches) {
      const firstProduct = root.querySelector('[data-pricing-product]');
      if (firstProduct) showPricing(firstProduct.dataset.pricingProduct);
    }
    root.addEventListener('click', (event) => {
      const target = event.target.closest('[data-pricing-filter], [data-pricing-select], [data-apparel-select], [data-event-request], [data-apparel-style]');
      if (!target || !root.contains(target)) return;
      if (target.matches('a') && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.defaultPrevented)) return;
      if (target.dataset.apparelStyle) {
        const styleInput = root.querySelector('[data-apparel-style-choice]');
        if (styleInput) {
          styleInput.value = target.dataset.apparelStyle;
          styleInput.dispatchEvent(new Event('input', {bubbles: true}));
        }
      }
      if (target.dataset.pricingFilter) showPricing(target.dataset.pricingFilter);
      if (target.dataset.pricingSelect) showPricing(target.dataset.pricingSelect);
      if (target.dataset.apparelSelect) {
        const choice = Array.from(root.querySelectorAll('[data-apparel-choice]')).find((input) => input.dataset.apparelChoice === target.dataset.apparelSelect);
        if (choice) {
          choice.checked = true;
          choice.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }
      if (target.hasAttribute('data-event-request')) {
        const fieldset = root.querySelector('[data-event-options]');
        if (fieldset) fieldset.querySelector('input')?.focus({preventScroll: true});
      }
    });
  }
  function initializeAll(scope) {
    scope.querySelectorAll('[data-mct-apparel]').forEach(initialize);
  }
  initializeAll(document);
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
